// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"d9a0c7a9","488":"1da4c527","557":"2e11a89c","687":"7b8e86e3","771":"057da3c6"}[chunkId] + ".chunk.js";
};